import React from 'react';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { ActiveFilterBanner } from './components/active-filter-banner';
import { MobileAddTaskButton } from './components/mobile-add-task-button';
import { PageTopBar } from './components/page-top-bar';
import { TasksList } from './components/tasks-list';
import * as Styled from './inbox.style';

export const Inbox: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.Inbox, undefined);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar />
          <Styled.Content>
            <ActiveFilterBanner />

            <TasksList />
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>

      <MobileAddTaskButton />
    </Styled.Container>
  );
};
